<template>

  <div class="mt-2 flex overflow-hidden flex-grow">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">

      <div class="w-full  h-10 ">
        <CGoBack/>
      </div>

      <div class=" flex-grow  px-10 h-full  flex  text-center justify-center overflow-hidden">
        <div class="flex flex-col bg-white rounded p-10  max-w-[1000px] flex-grow gap-2 overflow-hidden">

            <div class="flex flex-shrink-0 justify-center h-10  w-full bg-primary p-2 rounded">
                <span class="text-xl">Templates</span>
            </div>

            <div class="flex flex-shrink-0">
              <span class="bg-primary w-[200px] p-2 rounded">Name</span>
              <input class="border p-2 rounded w-full " v-model="name" data-ui="name">
            </div>

            <div class="flex flex-shrink-0">
              <span class="bg-primary w-[200px] p-2 rounded">Magazine Typ</span>
              <select class="border p-2 rounded w-full " v-model="magazineType" data-ui="magazineType">
                <option v-for="magazineType in magazineTypes" :key="magazineType.magazineTypeId"
                        :value="magazineType.magazineTypeId">{{ magazineType.magazineTypeTitle }}
                </option>
              </select>
            </div>

            <div class="flex flex-grow flex-col overflow-hidden">
              <PageGrid :template-id="templateId" :hide-save-button="true"></PageGrid>
            </div>

            <button
                class="flex-shrink-0 w-full rounded p-3 bg-trader-green hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out"
                data-ui="save-changes" @click="onClickSaveGridForTemplate">
              Speichern
            </button>

        </div>
      </div>
    </div>


    <sidebar/>

  </div>
</template>

<script>
import sidebar from "@/components/Administration/Sidebar.vue";
import PageGrid from "@/components/PageGrid/PageGrid.vue";
import SignalBus from "@/application/SignalBus";
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import router from "@/router";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";


export default {
  components: {CGoBack, PageGrid, sidebar},
  data() {
    return {
      templateId: 0,
      template: {},
      name: "",
      magazineType: "",
      copy: "",
      magazineTypes: []
    }
  },
  methods: {
    async onClickSaveGridForTemplate() {

      const templateData = {
        name: this.name,
        magazineTypeId: this.magazineType,
        templateId: this.templateId
      };

      const mutation = gql`
        mutation editPageTemplateInfo($pageTemplate: PageTemplateInput!) {
          editPageTemplateInfo(pageTemplate: $pageTemplate) {
            success
          }
        }
      `;
      try {
        const variables = {
          pageTemplate: templateData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        // Prüfen, ob die Mutation erfolgreich war, bevor zur Administration-Seite weitergeleitet wird.
        if (data.editPageTemplateInfo.success) {

          SignalBus.emit("save_grid_for_template",{
            hideModal: true,
          });

          eventBus.setData({
            title: "Template gespeichert",
            message: "Das Template wurde gespeichert.",
          });
          eventBus.openModal(SuccessConfirmation);

        }
      } catch (error) {
        console.error(error);
      }


    },
    goBack() {
      router.push("/administration")
    },
    async getTemplateInfo() {
      try {
        const response = await apolloClient.query({
          query: gql`
             query getTemplateInfo($templateId: Int!) {
               getTemplateInfo(templateId: $templateId) {
                  name
                  magazineType
                  copy
              }
            }
            `,
          variables: {
            templateId: this.templateId
          }
        });
        this.template = response.data.getTemplateInfo;

        this.name = this.template.name;
        this.magazineType = this.template.magazineType;
        this.copy = this.template.copy;

      } catch (error) {
        console.error("Fehler beim Abrufen der teamDaten:", error);
      }

    },
    async getMagazineTypes() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query getMagazineTypes {
              getMagazineTypes {
                magazineTypeId
                magazineType
                magazineTypeTitle
                supportMarkets

              }
            }
          `
        });

        this.magazineTypes = response.data.getMagazineTypes;

      } catch (error) {
        console.error("Fehler beim Abrufen der magazineTypes:", error);
      }
    },

  },
  mounted() {
    this.getTemplateInfo();
    this.getMagazineTypes();
  },
  watch: {
    '$route.params.templateId': function (newId) {
      this.templateId = newId;
      this.getTemplateInfo();
      SignalBus.emit("load_grid_for_template", newId);
    },
  },
  created() {
    if (this.$route.params.templateId != null && typeof this.$route.params.templateId != 'undefined' && this.$route.params.templateId != '') {
      this.templateId = this.$route.params.templateId;
    }
  }
}
</script>

